export function linear(t) {
  return +t;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/~/d3-ease/src/linear.js
// module id = ../../../../d3-ease/src/linear.js
// module chunks = 4